module.exports = __webpack_public_path__ + "static/media/onogate-preview.48cf48fd.png";